import { IConstraintWaterExpress } from '../../interfaces/iconstraint-water-express';
import { Scenario } from '../scenario';

export class ConstraintWaterExpressBase {
  ConstraintWaterExpressId: number;
  ScenarioId: number;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;

  constructor(item?: IConstraintWaterExpress) {
    if (item) {

      this.ConstraintWaterExpressId = item.ConstraintWaterExpressId;
      this.ScenarioId = item.ScenarioId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
    }
  }
}